import constants from "src/constants";

function getSortedContentByLanguage(lang: string, array: any[]) {
  const languageOrder =
    constants.LocalePriority[constants.Locales[lang]?.language] ||
    constants.LocalePriority.default;

  const sortedArray = array.sort((a, b) => {
    if (b.language === null) {
      return -1;
    } else if (a.language === null) {
      return 1;
    } else {
      return (
        languageOrder.indexOf(a.language) - languageOrder.indexOf(b.language)
      );
    }
  });

  return sortedArray;
}

export default getSortedContentByLanguage;
